const CARD_TYPES = {
  visa: 'VISA',
  mastercard: 'MC',
  discover: 'DISC',
  'american express': 'AMEX',
};

/**
 * Abbreviates an input card type
 * @param cardType The long card type
 * @returns The abbreviated card type
 */
export function shortenCCType(cardType: string): string {
  return CARD_TYPES[cardType.toLowerCase()] || 'CC';
}
